import { FC, ChangeEvent, useState } from 'react';
import { format } from 'date-fns';
import numeral from 'numeral';
import PropTypes from 'prop-types';
import {
  Tooltip,
  Divider,
  Box,
  FormControl,
  InputLabel,
  Card,
  Checkbox,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableContainer,
  Select,
  MenuItem,
  Typography,
  useTheme,
  CardHeader,
  Button
} from '@mui/material';

import axios from 'axios';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import Payment from '@mui/icons-material/Payment';
import { updateDialogOpen, updateVal, updateDialogOpenCourier, postCustomerNotification, updateDialogOpenLabelNama, updateDialogOpenSpecialRequest } from 'src/redux/OrderPostRedux';
import { updateDialogOpen as updateDialogOpenPayment, updateVal as updateValPayment } from 'src/redux/OrderPaymentPostRedux';
import { useAppDispatch } from 'src/reduxhooks';
import OrderInvoice from './OrderInvoice';
import { fetchAllPrintPdf, fetchOrdersList, fetchUserCourierLabelPdf, fetchUserPersonalizedLabelsPdf, fetchUserShipmentLabelPdf, fetchUserShipmentLabelPdfLong, fetchWorkInputFormPdf, registerBatchAndFetchAllPrintPdf } from 'src/redux/OrderListRedux';
import { pdf, PDFViewer } from '@react-pdf/renderer';
import { useLocation } from 'react-router-dom';
import React from 'react';

interface RecentOrdersTableProps {
  className?: string;
  ordersList: any[];
}

interface Filters {
  status?: "settlement" | "pending" | "expire"; 
}

function compare( a: any, b: any ) {
  if ( a.orderId > b.orderId ){
    return -1;
  }
  if ( a.orderId < b.orderId ){
    return 1;
  }
  return 0;
}
const applyFilters = (
  cryptoOrders: any[],
  filters: Filters
): any[] => {
  return cryptoOrders.filter((cryptoOrder) => {
    let matches = true;

    if (filters.status) {
      if (cryptoOrder.paymentStatus !== filters.status) {
        matches = false;
      }
      if (cryptoOrder.paymentStatus === "capture" && filters.status === "settlement") {
        matches = true;
      }
      if (cryptoOrder.paymentStatus === "capture_stockonly" && filters.status === "settlement") {
        matches = true;
      }
      if (cryptoOrder.paymentStatus === "capture_marketplace" && filters.status === "settlement") {
        matches = true;
      }
    }

    if (filters.status === "expire" && cryptoOrder.paymentStatus === "abandoned") {
      matches = true;
    }

    return matches;
  });
};


const applyPagination = (
  ordersList: any[],
  page: number,
  limit: number
): any[] => {
  if (page === -1) {
    return [];
  }
  return ordersList.slice(page * limit, page * limit + limit);
};


function formatDate(difference) {
  // Arrange the difference of date in days, hours, minutes, and seconds format
  let days = Math.floor(difference / (1000 * 60 * 60 * 24));
  let hours = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  let minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
  return " (" + days + " days, " + hours + " hours, " + minutes + " minutes)";
}
export function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

function isOrderObjectVersionSettled(order: any) {
  // Order object is settled when the order is marketplace, OR the payment time is more than 40 minutes ago. 
  // Customer has 30 minutes time.
  return order.paymentStatus === "capture_marketplace" || 
  (new Date(order.fetchTime || new Date().toISOString()).getTime() >
    new Date(order.paymentDateTime || order.creationDateTime).getTime() + (40 * 60 * 1000)); // 40 Minutes
}

const RecentOrdersTable: FC<RecentOrdersTableProps> = ({ ordersList }) => {
  let query = useQuery();
  const dispatch = useAppDispatch();

  const [isRefreshing, setIsRefreshing] = useState<boolean>(false);
  const [page, setPage] = useState<number>(0);
  const [limit, setLimit] = useState<number>(10);
  const [filters, setFilters] = useState<Filters>({
    status: "settlement"
  });

  // Invoice PDF
  function generateOrderShippingDetail() {
    const blob = pdf(<OrderInvoice/>).toBlob();
    
    blob.then(function (blob) {
      const fileURL = URL.createObjectURL(blob);
      const pdfWindow = window.open();
      pdfWindow.location.href = fileURL;
    });
  }

  const statusOptions = [
    {
      id: 'settlement',
      name: 'Paid'
    },
    {
      id: 'pending',
      name: 'Waiting For Payment'
    },
    {
      id: 'expire',
      name: 'Not Paid'
    },
    {
      id: '',
      name: 'All'
    },
  ];

  const handleStatusChange = (e: ChangeEvent<HTMLInputElement>): void => {
    let value = null;

    if (e.target.value !== 'all') {
      value = e.target.value;
    }

    setFilters((prevFilters) => ({
      ...prevFilters,
      status: value
    }));

    setPage(0);
  };

  const handlePageChange = (event: any, newPage: number): void => {
    setPage(newPage);
  };

  const handleLimitChange = (event: ChangeEvent<HTMLInputElement>): void => {
    setLimit(parseInt(event.target.value));
  };

  var toBeSortedOrdersList = [...ordersList];

  const sortedCryptoOrders = toBeSortedOrdersList.sort(compare);
  const filteredCryptoOrders = applyFilters(sortedCryptoOrders, filters);

  // if (page === -1) {
  //   setPage(Math.floor(filteredCryptoOrders.length / limit));
  // }

  const paginatedCryptoOrders = applyPagination(
    filteredCryptoOrders,
    page,
    limit
  );
  const theme = useTheme();

  const refreshOrderFunction = (arg: string) => {
    setIsRefreshing(true);
    dispatch(fetchOrdersList(arg));
    setTimeout(() => {
      setIsRefreshing(false);
    }, 2500);
  }

  return (
    <Card>
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow style={{}}>
            <Typography style={{padding: '20px 26px', fontWeight: 'bold', fontSize: '17px'}}>MARKETPLACE - KIRIM SEKARANG JUGA!!!!!!</Typography>
          </TableRow>
          <TableRow>
            {/* <TableCell>User Sub</TableCell> */}
            <TableCell>Order ID & Waktu Pesan</TableCell>
            {/* <TableCell>Waktu Pesan</TableCell> */}
            <TableCell>HARUS DIKIRIM</TableCell>
            <TableCell style={{
                  maxWidth: "100px"
                }}>Total Order/ Payment Amount</TableCell>
            <TableCell style={{
                  maxWidth: "150px"
                }}>Name</TableCell>
            <TableCell>Catatan & Alamat</TableCell>
            <TableCell>Payment Status</TableCell>
            <TableCell>Shipment Status</TableCell>
            <TableCell>Ship Complete Time</TableCell>
            <TableCell>Edit</TableCell>
            <TableCell>Dikasih Meas Kit?</TableCell>
            <TableCell>Form Kerja</TableCell>
            <TableCell>Sticker Item</TableCell>
            {/* <TableCell>Sticker Resi Biasa</TableCell> */}
            <TableCell>Sticker Alamat</TableCell>
            <TableCell>Sticker Kurir</TableCell>
            <TableCell>Request Pickup</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedCryptoOrders.filter(order => order.paymentStatus === "capture_marketplace").map((order: any) => {
            var orderTimeString = "TIDAK ADA";
            var shipDateString = "LEWAT (!!!)";
            if (order?.creationDateTime) {
              const orderCreationTime = new Date(order.creationDateTime);
              orderTimeString = orderCreationTime.toLocaleString('en-US', {timeZone: 'Asia/Jakarta'});

              var dayName = orderCreationTime.toLocaleString("en-US", {
                timeZone: 'Asia/Jakarta',
                weekday: 'long'
              });
              var daysUntilFinalShipTime = 
                dayName === "Friday" ? 3 : 
                dayName === "Saturday" ? 3 : 
                dayName === "Sunday" ? 3 :
                2;

              var shipTime = new Date();
              shipTime.setTime(orderCreationTime.getTime() + ((daysUntilFinalShipTime - 1) * 24 * 3600 * 1000));
              var finalShipTime = new Date();
              finalShipTime.setTime(orderCreationTime.getTime() + ((daysUntilFinalShipTime) * 24 * 3600 * 1000));

              var orderDateStr = orderCreationTime.toLocaleDateString('sv-SE', {timeZone: 'Asia/Jakarta', day: "2-digit", month: "2-digit", year: '2-digit'});
              var shipDateStr = shipTime.toLocaleDateString('sv-SE', {timeZone: 'Asia/Jakarta', day: "2-digit", month: "2-digit", year: '2-digit'});
              var finalShipDateStr = finalShipTime.toLocaleDateString('sv-SE', {timeZone: 'Asia/Jakarta', day: "2-digit", month: "2-digit", year: '2-digit'});
        
              const currentDateString = new Date().toLocaleDateString('sv-SE', {timeZone: 'Asia/Jakarta', day: "2-digit", month: "2-digit", year: '2-digit'});

              if (currentDateString === finalShipDateStr || order.paymentStatus === "capture_marketplace") {
                shipDateString = "HARI TERAKHIR (!!)";
              }
              else if (currentDateString > orderDateStr && currentDateString <= shipDateStr) {
                shipDateString = "HARI INI (!)";
              }
              else if (currentDateString === orderDateStr) {
                shipDateString = "MULAI KERJAKAN";
              }
            }

            var shipmentTimeString = "-";
            if (order?.shipmentTime) {
              const orderCreationTime = new Date(order.shipmentTime);
              shipmentTimeString = orderCreationTime.toLocaleString('en-US', {timeZone: 'Asia/Jakarta'});

              // Get time difference
              shipmentTimeString = shipmentTimeString +
                formatDate(new Date(order.shipmentTime).getTime() - new Date(order.creationDateTime).getTime());
            }

            if (order.shipmentStatus === "SHIPPED") {
              shipDateString = "-";
            }

            return (
              <TableRow
                hover
                key={order.orderId}
                style={order.shipmentStatus === "SHIPPED" ? {
                  backgroundColor: "#b3ffb9"
                } : order.paymentStatus === "capture_marketplace" ? {
                  backgroundColor: "#ff4545"
                } : shipDateString === "LEWAT (!!!)" ? {
                  backgroundColor: "#ff4545"
                } : shipDateString === "HARI TERAKHIR (!!)"  ? {
                  backgroundColor: "#f48d2e"
                } : shipDateString === "HARI INI (!)" ? {
                  backgroundColor: "#ffdb46"
                } : undefined}
              >
                {/* <TableCell>
                  <Typography
                    variant="body1"
                    fontWeight="bold"
                    color="text.primary"
                    gutterBottom
                    noWrap
                  >
                    {order.userSub}
                  </Typography>
                </TableCell> */}
                <TableCell>
                  <Typography
                    variant="body1"
                    fontWeight="bold"
                    color="text.primary"
                    gutterBottom
                    noWrap
                    style={{
                      backgroundColor: '#232323',
                      color: '#ffffff',
                      padding: '4px 8px',
                      borderRadius: '40px',
                      width: 'fit-content',
                      fontSize: '10px',
                      marginBottom: '4px'
                    }}
                  >
                    {orderTimeString} 
                  </Typography>
                  <Typography
                    variant="body1"
                    fontWeight="bold"
                    color="text.primary"
                    gutterBottom
                    noWrap
                  >
                    {order.orderId}
                  </Typography>
                  <Typography
                    variant="body1"
                    fontWeight="regular"
                    color="text.primary"
                    gutterBottom
                    noWrap
                    style={{fontSize: '10px'}}
                  >
                    {(order?.courierOrderId ? " (" + order.courierOrderId + ")" : "")}
                  </Typography>
                  <Typography
                    variant="body1"
                    fontWeight="regular"
                    color="text.primary"
                    gutterBottom
                  >
                    {order?.cartProductList?.map((objItem) => (objItem?.productDetail?.name ?? '') + ' ' + (objItem?.sizeType === 'regular' ? ('<' + objItem?.regularSize + '>') : '<Uk Custom>') + ': ' + (objItem?.amount ?? '0') ).join(', ')}
                  </Typography>
                  {
                    query.get("userpass") === "kecoatidur" ?
                    <Button onClick={() => {
                      const customerNotifyBody = {
                        "messageType": "order_tracking",
                        "orderId": order.orderId,
                        "customerNumber": order.phoneNumber,
                      };

                      dispatch(postCustomerNotification(customerNotifyBody));
                    }}>KIRIM KONFIRMASI LAGI</Button>:
                    null
                  }
                </TableCell>
                {/* <TableCell>
                  <Typography
                    variant="body1"
                    fontWeight="bold"
                    color="text.primary"
                    gutterBottom
                    noWrap
                  >
                    {orderTimeString} 
                  </Typography>
                </TableCell> */}
                <TableCell>
                  <Typography
                    variant="body1"
                    fontWeight="bold"
                    color="text.primary"
                    gutterBottom
                    noWrap
                  >
                    {shipDateString + (order?.courierSelectionObject?.service ? " (" + order.courierSelectionObject.service.toUpperCase() + ")" : "")} 
                  </Typography>
                </TableCell>
                <TableCell style={{
                  maxWidth: "120px"
                }}>
                  <Typography
                    variant="body1"
                    fontWeight="bold"
                    color="text.primary"
                    gutterBottom
                  >
                    {order.totalCartAmount + "/" + order.totalPaymentAmount}
                  </Typography>
                  <Typography
                    variant="body1"
                    color="text.primary"
                    gutterBottom
                  >
                    {(order.totalPaymentAmount + Number(new Date(order?.creationDateTime).getTime() % 500))}
                  </Typography>
                  {
                    order?.coupon && order?.coupon?.couponKey ? 
                    <Typography
                      variant="body1"
                      // fontWeight="bold"
                      color="text.primary"
                      gutterBottom
                    >
                      ({order.coupon.couponKey?.includes("WAPROMO") ? "BLAST PROMO" : order.coupon.couponKey})
                    </Typography>
                    : null
                  }
                </TableCell>
                <TableCell style={{
                  maxWidth: "150px"
                }}>
                  <Typography
                    variant="body1"
                    fontWeight="bold"
                    color="text.primary"
                    gutterBottom
                  >
                    {order?.orderName ? order.orderName : "CUST"}
                  </Typography>
                </TableCell>
                <TableCell align="left" style={{
                  maxWidth: "300px"
                }}>
                  {
                    (order as any)?.orderSpecialRequest?.notes ?
                    <Typography
                      variant="body1"
                      style={{
                        fontWeight: 600,
                        borderRadius: '6px',
                        border: '1px solid #9f9f9f',
                        padding: '5px 8px',
                        textUnderlineOffset: '3px'
                      }}
                      color="text.primary"
                      gutterBottom
                      noWrap
                    >
                      <u>CATATAN: </u>{(order as any)?.orderSpecialRequest?.notes} 
                    </Typography>
                    : null
                  }
                  <Typography
                    variant="body1"
                    fontWeight="bold"
                    color="text.primary"
                    gutterBottom
                    noWrap
                  >
                    {
                      order.address
                    }
                  </Typography>
                  <Typography
                    variant="body1"
                    fontWeight="bold"
                    color="text.primary"
                    gutterBottom
                    noWrap
                  >
                    ({order.phoneNumber})
                  </Typography>
                  <IconButton
                    sx={{
                      '&:hover': {
                        background: theme.colors.primary.lighter
                      },
                      color: theme.palette.primary.main
                    }}
                    color="inherit"
                    size="small"
                    onClick={() => {
                      dispatch(updateVal(order));
                      dispatch(updateDialogOpenSpecialRequest(true));
                    }}
                  >
                    <EditTwoToneIcon fontSize="small" />
                  </IconButton>
                </TableCell>
                <TableCell align="right">
                  <Typography
                    variant="body1"
                    fontWeight="bold"
                    color="text.primary"
                    gutterBottom
                    noWrap
                  >
                    {order.paymentStatus}
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography
                    variant="body1"
                    fontWeight="bold"
                    color="text.primary"
                    gutterBottom
                    noWrap
                  >
                    {order.shipmentStatus + (order.shipmentStatus === "SHIPPED" ? ": " + order.shipmentTrackingNumber : "") }
                  </Typography>
                </TableCell>
                <TableCell align="right">
                  <Typography
                    variant="body1"
                    fontWeight="bold"
                    color="text.primary"
                    gutterBottom
                    noWrap
                  >
                    {shipmentTimeString}
                  </Typography>
                </TableCell>
                <TableCell align="right">
                    {
                      (order.paymentStatus === "capture" || order.paymentStatus === "capture_stockonly" || order.paymentStatus === "settlement" || order.paymentStatus === "capture_marketplace") 
                      && order.shipmentStatus !== "SHIPPED" ?
                      <Tooltip title="Update Order" arrow>
                        <IconButton
                          sx={{
                            '&:hover': {
                              background: theme.colors.primary.lighter
                            },
                            color: theme.palette.primary.main
                          }}
                          color="inherit"
                          size="small"
                          onClick={() => {
                            dispatch(updateVal(order));
                            dispatch(updateDialogOpen(true));
                          }}
                        >
                          <EditTwoToneIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>:
                      null
                    }
                    {
                      order.paymentStatus === "unpaid" ?
                      <Tooltip title="Update Order Payment Status" arrow>
                        <IconButton
                          sx={{
                            '&:hover': {
                              background: theme.colors.primary.lighter
                            },
                            color: theme.palette.primary.main
                          }}
                          color="inherit"
                          size="small"
                          onClick={() => {
                            dispatch(updateValPayment(order));
                            dispatch(updateDialogOpenPayment(true));
                          }}
                        >
                          <Payment fontSize="small" />
                        </IconButton>
                      </Tooltip>:
                      null
                    }
                    {
                      (order.paymentStatus === "capture" || order.paymentStatus === "capture_stockonly" || order.paymentStatus === "settlement") 
                      && order.shipmentStatus === "SHIPPED" ?
                      <Button variant="outlined" 
                      disabled={!(order.orderName && order.phoneNumber && order.orderId && order.paidOrderCount && order.shipmentPhoto)}
                      onClick={() => {
                        const customerNotifyBody = {
                          "messageType": "order_shipped",
                          "customerName": order.orderName,
                          "customerNumber": order.phoneNumber,
                          "shipmentNumber": undefined,
                          "orderId": order.orderId,
                          "paidOrderCount": order.paidOrderCount,
                          "shipmentPhoto": "https://files-far-east.s3.ap-southeast-1.amazonaws.com/general/" + encodeURIComponent(order.shipmentPhoto) + ".jpg",
                          "courierBrand": order?.courierSelectionObject?.service ? order.courierSelectionObject.service : ''
                        };

                        dispatch(postCustomerNotification(customerNotifyBody));
                      }}>
                        Kabari Ulang
                      </Button>: 
                      null
                    }
                </TableCell>
                <TableCell>
                  <Typography
                    variant="body1"
                    fontWeight="bold"
                    color="text.primary"
                    gutterBottom
                    noWrap>
                    {
                      (!order.paidOrderCount || order?.paidOrderCount === 1) ? "KASIH MEAS KIT" : "- (SUDAH PUNYA)"
                    }
                  </Typography>
                </TableCell>
                <TableCell>
                  <Button variant="outlined" onClick={() => {
                    dispatch(fetchWorkInputFormPdf(order));
                  }}>
                    Print Form
                  </Button>
                  {
                    order?.orderBatchPrintId ?
                    <Typography style={{fontSize: '7px', marginTop: '2px'}} onClick={() => {
                      const orderListNotPrinted = sortedCryptoOrders.filter((orderObj) => 
                        (orderObj.paymentStatus === "capture" || orderObj.paymentStatus === "settlement" || orderObj.paymentStatus === "capture_marketplace") &&
                        (orderObj.shipmentStatus !== "SHIPPED") &&
                        (orderObj.orderBatchPrintId === order.orderBatchPrintId)
                      );
                      if (orderListNotPrinted?.length) {
                        dispatch(fetchAllPrintPdf(orderListNotPrinted));
                      }
                    }}>{order.orderBatchPrintId}</Typography>
                    : null
                  }
                </TableCell>
                <TableCell>
                  <Box style={{display:'flex', flexDirection: 'row'}}>
                    <Button variant="outlined" onClick={() => {
                      dispatch(fetchUserPersonalizedLabelsPdf(order));
                    }}>
                      Print Label
                    </Button>
                    <IconButton
                    sx={{
                      '&:hover': {
                        background: theme.colors.primary.lighter
                      },
                      color: theme.palette.primary.main,
                      marginLeft: '15px',
                    }}
                    color="inherit"
                    disabled={!(order.paymentStatus === "capture" || order.paymentStatus === "capture_stockonly" || order.paymentStatus === "settlement")}
                    size="small" onClick={() => {
                      dispatch(updateVal(order));
                      dispatch(updateDialogOpenLabelNama(true));
                    }}>
                      <Payment fontSize="small" />
                    </IconButton>
                  </Box>
                  <Typography
                    style={{
                      marginTop: '5px',                        
                      fontWeight: 300,
                      fontSize: '8px',
                    }}
                    gutterBottom>
                    {
                      order?.labelNamaManualArray?.join(", ")
                    }
                  </Typography>
                </TableCell>
                {/* <TableCell>
                  <Button variant="outlined" disabled={order?.paymentStatus === "capture_marketplace"} onClick={() => {
                    dispatch(fetchUserShipmentLabelPdf(order));
                  }}>
                    Alamat Biasa
                  </Button>
                </TableCell> */}
                <TableCell>
                  {/* <Button variant="outlined" disabled={order?.paymentStatus === "capture_marketplace"} onClick={() => {
                    dispatch(fetchUserShipmentLabelPdfLong(order));
                  }}>
                    Print Alamat
                  </Button> */}
                </TableCell>
                <TableCell>
                  {
                    order?.paymentStatus === "capture_marketplace" || order?.paymentStatus === "capture_review"?
                    <Button variant="outlined" onClick={() => {
                      axios({
                        method: 'post',
                        url: "https://i3fxe6nvj7.execute-api.ap-southeast-1.amazonaws.com/prod/jubelio-proxy",
                        data: JSON.stringify({
                          "action": "GET-SHIPPING-LABEL",
                          "jubelioSalesOrderId": order?.courierOrderId,
                        })
                      }).then((response) => {
                        if (response?.data?.success && response?.data?.labelUrl) {
                          window.open(response?.data?.labelUrl, '_blank');
                        }
                      });
                    }}>
                      Print Label Kurir (Marketplace)
                    </Button>:
                    null
                  }
                  {
                    order.courierAwb && order.courierOrderId && order?.paymentStatus !== "capture_marketplace" && order?.paymentStatus !== "capture_review"?
                    <Button variant="outlined" onClick={() => {
                      dispatch(fetchUserCourierLabelPdf(order));
                    }}>
                      Print Label Kurir
                    </Button>:
                    order.courierSelectionObject && 
                    order.courierRequestPickupSchedule &&
                    order.courierOrderId &&
                    !order.courierAwb ?
                    <Button variant="outlined" onClick={() => refreshOrderFunction(order.courierOrderId)} 
                    disabled={isRefreshing}>
                      {isRefreshing ? "Mengupdate..." : "Cek Status Resi"}
                    </Button>:
                    null
                  }
                </TableCell>
                <TableCell>
                  {
                    order.shipmentStatus !== "SHIPPED" &&
                    order.courierSelectionObject && 
                    !order.courierRequestPickupSchedule && 
                    (order.paymentStatus === "capture" || order.paymentStatus === "capture_stockonly" || order.paymentStatus === "settlement") &&
                    order?.paymentStatus !== "capture_marketplace" ? 
                    <Button variant="outlined" onClick={() => {
                      dispatch(updateVal(order));
                      dispatch(updateDialogOpenCourier(true));
                    }} 
                    disabled={(order as any)?.orderSpecialRequest?.manualShipping}>
                      {(order as any)?.orderSpecialRequest?.manualShipping ? "Kirim Manual" : "Request Pickup"}
                    </Button>:
                    order.courierSelectionObject && order.courierRequestPickupSchedule ? 
                    <Typography>PICKUP {order.courierRequestPickupSchedule}</Typography>:
                    null
                  }
                  {
                    order.shipmentStatus === "SHIPPED" && order.paymentStatus === "capture_marketplace" ? 
                    <Button variant="outlined" disabled={!(query.get("userpass") === "kecoatidur")} 
                    onClick={() => {
                      axios({
                        method: 'post',
                        url: 'https://i3fxe6nvj7.execute-api.ap-southeast-1.amazonaws.com/prod/order', // Endpoint for order update
                        data: JSON.stringify({
                          userSub: order.userSub,
                          creationDateTime: order.creationDateTime,
                          updateType: "captureMarketplaceReview",
                        })
                      }).then((response) => {
                        dispatch(fetchOrdersList(''));
                      });
                    }}>
                      Set As Review
                    </Button>:
                    null
                  }
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
      <CardHeader
        action={
          <Box width={400}>
            <Box style={{
              display: "flex",
              flexDirection: "row",
            }}>
              <Button variant='contained' 
              style={{
                width: "130px",
                marginRight: "8px",
              }}
              onClick={() => {
                // Register a new batch ID, then print the orders
                const orderListNotPrinted = sortedCryptoOrders.filter((orderObj) => 
                  (orderObj.paymentStatus === "capture" || orderObj.paymentStatus === "settlement" || orderObj.paymentStatus === "capture_marketplace") &&
                  (orderObj.shipmentStatus !== "SHIPPED") &&
                  (orderObj.orderBatchPrintId === undefined) &&
                  (isOrderObjectVersionSettled(orderObj)) // Only print settled orders
                );
                if (orderListNotPrinted?.length) {
                  dispatch(registerBatchAndFetchAllPrintPdf(orderListNotPrinted));
                }
              }}>
                Print Semua
              </Button>
              <Button variant="outlined" onClick={() => refreshOrderFunction("")} 
              style={{
                width: "130px",
                marginRight: "8px",
              }}
              disabled={isRefreshing}>
                {isRefreshing ? "Mengupdate..." : "Cek Data Terbaru"}
              </Button>
              <FormControl fullWidth variant="outlined">
                <InputLabel>Payment Status</InputLabel>
                <Select
                  value={filters.status}
                  onChange={handleStatusChange}
                  label="Payment Status"
                  autoWidth
                >
                  {statusOptions.map((statusOption) => (
                    <MenuItem key={statusOption.id} value={statusOption.id}>
                      {statusOption.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          </Box>
        }
        title="Recent Orders"
      />
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow style={{}}>
              <Typography style={{margin: '6px 0px 6px 13px', color: '#000000', fontSize: '18px'}}>
                <b>JUMLAH LEWAT KIRIM: </b>{ordersList.filter((order) => {
                  if (order.paymentStatus !== "settlement" && order.paymentStatus !== "capture" && order.paymentStatus !== "capture_stockonly" && order.paymentStatus !== "capture_marketplace") {
                    return false;
                  }

                  const currentDateString = new Date().toLocaleDateString('sv-SE', {timeZone: 'Asia/Jakarta', day: "2-digit", month: "2-digit", year: '2-digit'});

                  const orderCreationTime = new Date(order.creationDateTime); // Ingest ISO time

                  var dayName = orderCreationTime.toLocaleString("en-US", {
                    timeZone: 'Asia/Jakarta',
                    weekday: 'long'
                  });
                  var daysUntilFinalShipTime = 
                    dayName === "Friday" ? 3 : 
                    dayName === "Saturday" ? 3 : 
                    dayName === "Sunday" ? 3 :
                    2;

                  var shipTime = new Date();
                  shipTime.setTime(orderCreationTime.getTime() + ((daysUntilFinalShipTime - 1) * 24 * 3600 * 1000));
                  var finalShipTime = new Date();
                  finalShipTime.setTime(orderCreationTime.getTime() + (daysUntilFinalShipTime * 24 * 3600 * 1000)); // Increment by 2 days

                  var finalShipDateStr = finalShipTime.toLocaleDateString('sv-SE', {timeZone: 'Asia/Jakarta', day: "2-digit", month: "2-digit", year: '2-digit'});

                  return order.shipmentStatus !== "SHIPPED" && 
                  (currentDateString > finalShipDateStr);
                })?.length} PESANAN
              </Typography>
              <Typography style={{margin: '6px 0px 1px 13px', color: '#000000'}}>
                <b>JUMLAH HARI TERAKHIR KIRIM: </b>{ordersList.filter((order) => {
                  if (order.paymentStatus !== "settlement" && order.paymentStatus !== "capture" && order.paymentStatus !== "capture_stockonly" && order.paymentStatus !== "capture_marketplace") {
                    return false;
                  }

                  const currentDateString = new Date().toLocaleDateString('sv-SE', {timeZone: 'Asia/Jakarta', day: "2-digit", month: "2-digit", year: '2-digit'});

                  const orderCreationTime = new Date(order.creationDateTime); // Ingest ISO time

                  var dayName = orderCreationTime.toLocaleString("en-US", {
                    timeZone: 'Asia/Jakarta',
                    weekday: 'long'
                  });
                  var daysUntilFinalShipTime = 
                    dayName === "Friday" ? 3 : 
                    dayName === "Saturday" ? 3 : 
                    dayName === "Sunday" ? 3 :
                    2;

                  var finalShipTime = new Date();
                  finalShipTime.setTime(orderCreationTime.getTime() + (daysUntilFinalShipTime * 24 * 3600 * 1000)); // Increment by 2 days

                  var finalShipDateStr = finalShipTime.toLocaleDateString('sv-SE', {timeZone: 'Asia/Jakarta', day: "2-digit", month: "2-digit", year: '2-digit'});

                  return order.shipmentStatus !== "SHIPPED" && currentDateString === finalShipDateStr;
                })?.length} PESANAN
              </Typography>
              <Typography style={{margin: '3px 0px 6px 13px', color: '#000000'}}>
                <b>JUMLAH BELUM KIRIM: </b>{ordersList.filter((order) => {
                  if (order.paymentStatus !== "settlement" && order.paymentStatus !== "capture" && order.paymentStatus !== "capture_stockonly" && order.paymentStatus !== "capture_marketplace") {
                    return false;
                  }

                  return order.shipmentStatus !== "SHIPPED";
                })?.length} PESANAN
              </Typography>
            </TableRow>
            <TableRow>
              {/* <TableCell>User Sub</TableCell> */}
              <TableCell>Order ID & Waktu Pesan</TableCell>
              {/* <TableCell>Waktu Pesan</TableCell> */}
              <TableCell>HARUS DIKIRIM</TableCell>
              <TableCell style={{
                    maxWidth: "100px"
                  }}>Total Order/ Payment Amount</TableCell>
              <TableCell style={{
                    maxWidth: "150px"
                  }}>Name</TableCell>
              <TableCell>Catatan & Alamat</TableCell>
              <TableCell>Payment Status</TableCell>
              <TableCell>Shipment Status</TableCell>
              <TableCell>Ship Complete Time</TableCell>
              <TableCell>Edit</TableCell>
              <TableCell>Dikasih Meas Kit?</TableCell>
              <TableCell>Form Kerja</TableCell>
              <TableCell>Sticker Item</TableCell>
              {/* <TableCell>Sticker Resi Biasa</TableCell> */}
              <TableCell>Sticker Alamat</TableCell>
              <TableCell>Sticker Kurir</TableCell>
              <TableCell>Request Pickup</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {paginatedCryptoOrders.map((order: any) => {
              const orderObjectVersionIsSettled = isOrderObjectVersionSettled(order);

              var orderTimeString = "TIDAK ADA";
              var shipDateString = "LEWAT (!!!)";
              if (order?.creationDateTime) {
                const orderCreationTime = new Date(order.creationDateTime);
                orderTimeString = orderCreationTime.toLocaleString('en-US', {timeZone: 'Asia/Jakarta'});

                var dayName = orderCreationTime.toLocaleString("en-US", {
                  timeZone: 'Asia/Jakarta',
                  weekday: 'long'
                });
                var daysUntilFinalShipTime = 
                  dayName === "Friday" ? 3 : 
                  dayName === "Saturday" ? 3 : 
                  dayName === "Sunday" ? 3 :
                  2;

                var shipTime = new Date();
                shipTime.setTime(orderCreationTime.getTime() + ((daysUntilFinalShipTime - 1) * 24 * 3600 * 1000));
                var finalShipTime = new Date();
                finalShipTime.setTime(orderCreationTime.getTime() + ((daysUntilFinalShipTime) * 24 * 3600 * 1000));

                var orderDateStr = orderCreationTime.toLocaleDateString('sv-SE', {timeZone: 'Asia/Jakarta', day: "2-digit", month: "2-digit", year: '2-digit'});
                var shipDateStr = shipTime.toLocaleDateString('sv-SE', {timeZone: 'Asia/Jakarta', day: "2-digit", month: "2-digit", year: '2-digit'});
                var finalShipDateStr = finalShipTime.toLocaleDateString('sv-SE', {timeZone: 'Asia/Jakarta', day: "2-digit", month: "2-digit", year: '2-digit'});
          
                const currentDateString = new Date().toLocaleDateString('sv-SE', {timeZone: 'Asia/Jakarta', day: "2-digit", month: "2-digit", year: '2-digit'});

                if (currentDateString === finalShipDateStr || order.paymentStatus === "capture_marketplace") {
                  shipDateString = "HARI TERAKHIR (!!)";
                }
                else if (currentDateString > orderDateStr && currentDateString <= shipDateStr) {
                  shipDateString = "HARI INI (!)";
                }
                else if (currentDateString === orderDateStr) {
                  shipDateString = "MULAI KERJAKAN";
                }
              }

              var shipmentTimeString = "-";
              if (order?.shipmentTime) {
                const orderCreationTime = new Date(order.shipmentTime);
                shipmentTimeString = orderCreationTime.toLocaleString('en-US', {timeZone: 'Asia/Jakarta'});

                // Get time difference
                shipmentTimeString = shipmentTimeString +
                  formatDate(new Date(order.shipmentTime).getTime() - new Date(order.creationDateTime).getTime());
              }

              if (order.shipmentStatus === "SHIPPED") {
                shipDateString = "-";
              }

              return (
                <TableRow
                  hover
                  key={order.orderId}
                  style={order.shipmentStatus === "SHIPPED" ? {
                    backgroundColor: "#b3ffb9"
                  } : order.paymentStatus === "capture_marketplace" ? {
                    backgroundColor: "#ff4545"
                  } : shipDateString === "LEWAT (!!!)" ? {
                    backgroundColor: "#ff4545"
                  } : shipDateString === "HARI TERAKHIR (!!)"  ? {
                    backgroundColor: "#f48d2e"
                  } : shipDateString === "HARI INI (!)" ? {
                    backgroundColor: "#ffdb46"
                  } : undefined}
                >
                  {/* <TableCell>
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      color="text.primary"
                      gutterBottom
                      noWrap
                    >
                      {order.userSub}
                    </Typography>
                  </TableCell> */}
                  <TableCell>
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      color="text.primary"
                      gutterBottom
                      noWrap
                      style={{
                        backgroundColor: orderObjectVersionIsSettled ? '#232323' : 'rgb(89, 0, 190)',
                        color: '#ffffff',
                        padding: '4px 8px',
                        borderRadius: '40px',
                        width: 'fit-content',
                        fontSize: '10px',
                        marginBottom: '4px'
                      }}
                    >
                      {orderTimeString} {orderObjectVersionIsSettled ? '' : " - BELUM FINAL"}
                    </Typography>
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      color="text.primary"
                      gutterBottom
                      noWrap
                    >
                      {order.orderId}
                    </Typography>
                    <Typography
                      variant="body1"
                      fontWeight="regular"
                      color="text.primary"
                      gutterBottom
                      noWrap
                      style={{fontSize: '10px'}}
                    >
                      {(order?.courierOrderId ? " (" + order.courierOrderId + ")" : "")}
                    </Typography>
                    <Typography
                      variant="body1"
                      fontWeight="regular"
                      color="text.primary"
                      gutterBottom
                    >
                      {order?.cartProductList?.map((objItem) => (objItem?.productDetail?.name ?? '') + ' ' + (objItem?.sizeType === 'regular' ? ('<' + objItem?.regularSize + '>') : '<Uk Custom>') + ': ' + (objItem?.amount ?? '0') ).join(', ')}
                    </Typography>
                    <Typography
                      variant="body1"
                      fontWeight="regular"
                      color="text.primary"
                      gutterBottom
                    >
                      DEADLINE POTONG: [{order?.itemsCutQueueSchedule?.join(', ')}]
                    </Typography>
                    <Typography
                      variant="body1"
                      fontWeight="regular"
                      color="text.primary"
                      gutterBottom
                    >
                      STATUS POTONG: [{order?.itemsCutQueueStatus?.map((objItem) => (objItem >= 2 ? `SUDAH (${objItem})` : `BELUM (${objItem})`)).join(', ')}]
                    </Typography>
                    <Typography
                      variant="body1"
                      fontWeight="regular"
                      color="text.primary"
                      gutterBottom
                    >
                      ITEM ORDER CODE: [{order?.itemsOrderCodeArray?.join(', ')}]
                    </Typography>
                    <Typography
                      variant="body1"
                      fontWeight="regular"
                      color="text.primary"
                      gutterBottom
                    >
                      LAST SCAN: [{order?.itemsCutQueueUpdateTime?.join(', ')}]
                    </Typography>
                    <Typography style={{fontSize: '8px'}}>{order.expressShipmentDate ? "EXPRESS " + order.expressShipmentDate : "EXPRESS - "}</Typography>
                    <Typography style={{fontSize: '8px'}}>{order.standardShipmentDate ? "STANDAR " + order.standardShipmentDate : "STANDAR - "}</Typography>
                    <Typography style={{fontSize: '8px'}}>{order.lateShipmentDate ? "TELAT " + order.lateShipmentDate : "TELAT - "}</Typography>
                  </TableCell>
                  {/* <TableCell>
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      color="text.primary"
                      gutterBottom
                      noWrap
                    >
                      {orderTimeString} 
                    </Typography>
                  </TableCell> */}
                  <TableCell>
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      color="text.primary"
                      gutterBottom
                      noWrap
                    >
                      {shipDateString + (order?.courierSelectionObject?.service ? " (" + order.courierSelectionObject.service.toUpperCase() + ")" : "")} 
                    </Typography>
                  </TableCell>
                  <TableCell style={{
                    maxWidth: "120px"
                  }}>
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      color="text.primary"
                      gutterBottom
                    >
                      {order.totalCartAmount + "/" + order.totalPaymentAmount}
                    </Typography>
                    <Typography
                      variant="body1"
                      color="text.primary"
                      gutterBottom
                    >
                      {(order.totalPaymentAmount + Number(new Date(order?.creationDateTime).getTime() % 500))}
                    </Typography>
                    {
                      order?.coupon && order?.coupon?.couponKey ? 
                      <Typography
                        variant="body1"
                        // fontWeight="bold"
                        color="text.primary"
                        gutterBottom
                      >
                        ({order.coupon.couponKey?.includes("WAPROMO") ? "BLAST PROMO" : order.coupon.couponKey})
                      </Typography>
                      : null
                    }
                  </TableCell>
                  <TableCell style={{
                    maxWidth: "150px"
                  }}>
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      color="text.primary"
                      style={{marginBottom: '3px'}}
                    >
                      {order?.orderName ? order.orderName : "CUST"}
                    </Typography>
                    <a style={{fontSize: '8px', cursor: 'pointer'}}
                    onClick={() => {
                      (window as any).open("https://www.studios.id/order/" + order?.orderId, '_blank');
                    }}>LINK ORDER</a>
                  </TableCell>
                  <TableCell align="left" style={{
                    maxWidth: "300px"
                  }}>
                    {
                      (order as any)?.orderSpecialRequest?.notes ?
                      <Typography
                        variant="body1"
                        style={{
                          fontWeight: 600,
                          borderRadius: '6px',
                          border: '1px solid #9f9f9f',
                          padding: '5px 8px',
                          textUnderlineOffset: '3px'
                        }}
                        color="text.primary"
                        gutterBottom
                      >
                        <u>CATATAN: </u>{(order as any)?.orderSpecialRequest?.notes} 
                      </Typography>
                      : null
                    }
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      color="text.primary"
                      gutterBottom
                    >
                      {
                        order.address
                      }
                    </Typography>
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      color="text.primary"
                      gutterBottom
                      noWrap
                    >
                      ({order.phoneNumber})
                    </Typography>
                    <IconButton
                      sx={{
                        '&:hover': {
                          background: theme.colors.primary.lighter
                        },
                        color: theme.palette.primary.main
                      }}
                      color="inherit"
                      size="small"
                      onClick={() => {
                        dispatch(updateVal(order));
                        dispatch(updateDialogOpenSpecialRequest(true));
                      }}
                    >
                      <EditTwoToneIcon fontSize="small" />
                    </IconButton>
                  </TableCell>
                  <TableCell align="right">
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      color="text.primary"
                      gutterBottom
                      noWrap
                    >
                      {order.paymentStatus}
                    </Typography>
                    <Typography
                    style={{fontSize: '8px', fontWeight: 300}}
                      variant="body1"
                      fontWeight="bold"
                      color="text.primary"
                      gutterBottom
                      noWrap
                    >
                      {order?.paymentDateTime ? "(" + order.paymentDateTime + ")" : ""}
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      color="text.primary"
                      gutterBottom
                      noWrap
                    >
                      {order.shipmentStatus + (order.shipmentStatus === "SHIPPED" ? ": " + order.shipmentTrackingNumber : "") }
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      color="text.primary"
                      gutterBottom
                      noWrap
                    >
                      {shipmentTimeString}
                    </Typography>
                  </TableCell>
                  <TableCell align="right">
                      {
                        (order.paymentStatus === "capture" || order.paymentStatus === "capture_stockonly" || order.paymentStatus === "settlement" || order.paymentStatus === "capture_marketplace") 
                        && order.shipmentStatus !== "SHIPPED" ?
                        <Tooltip title="Update Order" arrow>
                          <IconButton
                            sx={{
                              '&:hover': {
                                background: theme.colors.primary.lighter
                              },
                              color: theme.palette.primary.main
                            }}
                            color="inherit"
                            size="small"
                            onClick={() => {
                              dispatch(updateVal(order));
                              dispatch(updateDialogOpen(true));
                            }}
                            disabled={!(query.get("userpass") === "kecoatidur")}
                          >
                            <EditTwoToneIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>:
                        null
                      }
                      {
                        order.paymentStatus === "unpaid" ?
                        <Tooltip title="Update Order Payment Status" arrow>
                          <IconButton
                            sx={{
                              '&:hover': {
                                background: theme.colors.primary.lighter
                              },
                              color: theme.palette.primary.main
                            }}
                            color="inherit"
                            size="small"
                            onClick={() => {
                              dispatch(updateValPayment(order));
                              dispatch(updateDialogOpenPayment(true));
                            }}
                          >
                            <Payment fontSize="small" />
                          </IconButton>
                        </Tooltip>:
                        null
                      }
                      {
                        (order.paymentStatus === "capture" || order.paymentStatus === "capture_stockonly" || order.paymentStatus === "settlement") 
                        && order.shipmentStatus === "SHIPPED" ?
                        <Button variant="outlined" 
                        disabled={!(order.orderName && order.phoneNumber && order.orderId && order.paidOrderCount && order.shipmentPhoto)}
                        onClick={() => {
                          const customerNotifyBody = {
                            "messageType": "order_shipped",
                            "customerName": order.orderName,
                            "customerNumber": order.phoneNumber,
                            "shipmentNumber": undefined,
                            "orderId": order.orderId,
                            "paidOrderCount": order.paidOrderCount,
                            "shipmentPhoto": "https://files-far-east.s3.ap-southeast-1.amazonaws.com/general/" + encodeURIComponent(order.shipmentPhoto) + ".jpg",
                            "courierBrand": order?.courierSelectionObject?.service ? order.courierSelectionObject.service : ''
                          };

                          dispatch(postCustomerNotification(customerNotifyBody));
                        }}>
                          Kabari Ulang
                        </Button>: 
                        null
                      }
                  </TableCell>
                  <TableCell>
                    <Typography
                      variant="body1"
                      fontWeight="bold"
                      color="text.primary"
                      gutterBottom
                      noWrap>
                      {
                        (!order.paidOrderCount || order?.paidOrderCount === 1) ? "KASIH MEAS KIT" : "- (SUDAH PUNYA)"
                      }
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Button variant="outlined" onClick={() => {
                      dispatch(fetchWorkInputFormPdf(order));
                    }}
                    disabled={!orderObjectVersionIsSettled}>
                      Print Form
                    </Button>
                    {
                      order?.orderBatchPrintId ?
                      <Typography style={{fontSize: '7px', marginTop: '2px'}} onClick={() => {
                        const orderListNotPrinted = sortedCryptoOrders.filter((orderObj) => 
                          (orderObj.paymentStatus === "capture" || orderObj.paymentStatus === "settlement" || orderObj.paymentStatus === "capture_marketplace") &&
                          (orderObj.shipmentStatus !== "SHIPPED") &&
                          (orderObj.orderBatchPrintId === order.orderBatchPrintId)
                        );
                        if (orderListNotPrinted?.length) {
                          dispatch(fetchAllPrintPdf(orderListNotPrinted));
                        }
                      }}>{order.orderBatchPrintId}</Typography>
                      : null
                    }
                  </TableCell>
                  <TableCell>
                    <Box style={{display:'flex', flexDirection: 'row'}}>
                      <Button variant="outlined" onClick={() => {
                        dispatch(fetchUserPersonalizedLabelsPdf(order));
                      }}
                      disabled={!orderObjectVersionIsSettled}>
                        Print Label
                      </Button>
                      <IconButton
                      sx={{
                        '&:hover': {
                          background: theme.colors.primary.lighter
                        },
                        color: theme.palette.primary.main,
                        marginLeft: '15px',
                      }}
                      color="inherit"
                      disabled={!(order.paymentStatus === "capture" || order.paymentStatus === "capture_stockonly" || order.paymentStatus === "settlement")}
                      size="small" onClick={() => {
                        dispatch(updateVal(order));
                        dispatch(updateDialogOpenLabelNama(true));
                      }}>
                        <Payment fontSize="small" />
                      </IconButton>
                    </Box>
                    <Typography
                      style={{
                        marginTop: '5px',                        
                        fontWeight: 300,
                        fontSize: '8px',
                      }}
                      gutterBottom>
                      {
                        order?.labelNamaManualArray?.join(", ")
                      }
                    </Typography>
                  </TableCell>
                  {/* <TableCell>
                    <Button variant="outlined" disabled={order?.paymentStatus === "capture_marketplace"} onClick={() => {
                      dispatch(fetchUserShipmentLabelPdf(order));
                    }}>
                      Alamat Biasa
                    </Button>
                  </TableCell> */}
                  <TableCell>
                    {/* <Button variant="outlined" disabled={order?.paymentStatus === "capture_marketplace" || !orderObjectVersionIsSettled} onClick={() => {
                      dispatch(fetchUserShipmentLabelPdfLong(order));
                    }}>
                      Print Alamat
                    </Button> */}
                  </TableCell>
                  <TableCell>
                    {
                      order?.paymentStatus === "capture_marketplace" || order?.paymentStatus === "capture_review"?
                      <Button variant="outlined" onClick={() => {
                        axios({
                          method: 'post',
                          url: "https://i3fxe6nvj7.execute-api.ap-southeast-1.amazonaws.com/prod/jubelio-proxy",
                          data: JSON.stringify({
                            "action": "GET-SHIPPING-LABEL",
                            "jubelioSalesOrderId": order?.courierOrderId,
                          })
                        }).then((response) => {
                          if (response?.data?.success && response?.data?.labelUrl) {
                            window.open(response?.data?.labelUrl, '_blank');
                          }
                        });
                      }}>
                        Print Label Kurir (Marketplace)
                      </Button>:
                      null
                    }
                    {
                      order.courierAwb && order.courierOrderId && order?.paymentStatus !== "capture_marketplace" && order?.paymentStatus !== "capture_review"?
                      <Button variant="outlined" onClick={() => {
                        dispatch(fetchUserCourierLabelPdf(order));
                      }}
                      disabled={!orderObjectVersionIsSettled}>
                        Print Label Kurir
                      </Button>:
                      order.courierSelectionObject && 
                      order.courierRequestPickupSchedule &&
                      order.courierOrderId &&
                      !order.courierAwb ?
                      <Button variant="outlined" onClick={() => refreshOrderFunction(order.courierOrderId)} 
                      disabled={isRefreshing}>
                        {isRefreshing ? "Mengupdate..." : "Cek Status Resi"}
                      </Button>:
                      null
                    }
                  </TableCell>
                  <TableCell>
                    {
                      order.shipmentStatus !== "SHIPPED" &&
                      order.courierSelectionObject && 
                      !order.courierRequestPickupSchedule && 
                      (order.paymentStatus === "capture" || order.paymentStatus === "capture_stockonly" || order.paymentStatus === "settlement") &&
                      order?.paymentStatus !== "capture_marketplace" ? 
                      <Button variant="outlined" onClick={() => {
                        dispatch(updateVal(order));
                        dispatch(updateDialogOpenCourier(true));
                      }} 
                      disabled={(order as any)?.orderSpecialRequest?.manualShipping}>
                        {(order as any)?.orderSpecialRequest?.manualShipping ? "Kirim Manual" : "Request Pickup"}
                      </Button>:
                      order.courierSelectionObject && order.courierRequestPickupSchedule ?
                      <>
                        <Typography>PICKUP {order.courierRequestPickupSchedule}</Typography>
                        <Typography>{order.shippedAt ? "SHIPPED-AT " + order.shippedAt : "NOT SHIPPED"}</Typography>
                        <Typography>{order.shipmentTime ? "SHIPMENT-TIME " + order.shipmentTime : "NOT SHIPPED"}</Typography>
                        <Typography>{order.shipmentUpdateTime ? "SHIPMENT-UTIME " + order.shipmentUpdateTime : "NOT SHIPPED"}</Typography>
                        <Typography>{order.courierStatusCode ? "SHIP STATUS " + order.courierStatusCode : "NO STATUS CODE"}</Typography>
                      </> :
                      null
                    }
                    {
                      order.shipmentStatus === "SHIPPED" && order.paymentStatus === "capture_marketplace" ? 
                      <Button variant="outlined" disabled={!(query.get("userpass") === "kecoatidur")} 
                      onClick={() => {
                        axios({
                          method: 'post',
                          url: 'https://i3fxe6nvj7.execute-api.ap-southeast-1.amazonaws.com/prod/order', // Endpoint for order update
                          data: JSON.stringify({
                            userSub: order.userSub,
                            creationDateTime: order.creationDateTime,
                            updateType: "captureMarketplaceReview",
                          })
                        }).then((response) => {
                          dispatch(fetchOrdersList(''));
                        });
                      }}>
                        Set As Review
                      </Button>:
                      null
                    }
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <Box p={2}>
        <TablePagination
          component="div"
          count={filteredCryptoOrders.length}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleLimitChange}
          page={page}
          rowsPerPage={limit}
          rowsPerPageOptions={[5, 10, 25, 30]}
        />
      </Box>
    </Card>
  );
};

RecentOrdersTable.propTypes = {
  ordersList: PropTypes.array.isRequired
};

RecentOrdersTable.defaultProps = {
  ordersList: []
};

export default RecentOrdersTable;
